import { actions, selectors } from 'data'
import { notifyError } from 'data/App/sagas'
import { HighRiskQuestionnaireType } from 'data/App/types'
import isNil from 'lodash/isNil'
import { call, put, select } from 'redux-saga/effects'
import { syncHighRisk } from 'services/api/kyc'

import { goToStep } from './common'

export default function* eddStep() {
  const Questionnaire: HighRiskQuestionnaireType = yield select(
    selectors.tierTwo.getQuestionnaireValues
  )

  if (!isNil(Questionnaire)) {
    const data = yield call(syncHighRisk, Questionnaire)

    if (data.error && data.error.cause !== 'Conflict') {
      yield call(notifyError, data.error.cause, 'KO_TIER_TWO')
    } else {
      yield put(actions.auth.getUser())
      yield call(goToStep, 'appComplete')
    }
  }
}
